<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="servicios"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Servicios Internacionales</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  icon
                  color="green"
                  @click="listar()"
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Actualizar</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-menu
              v-if="true"
              v-model="menuFechas"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2 mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Opciones</v-btn
                >
              </template>
              <v-card>
                <v-list>
                  <v-list-item>
                    <v-text-field
                      hide-details
                      type="date"
                      label="Desde"
                      v-model="fechaInicio"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>

                  <v-list-item>
                    <v-text-field
                      hide-details
                      type="date"
                      label="Hasta"
                      v-model="fechaFin"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>
                  <v-list-item>
                    <v-btn color="primary" dark @click="listarBusqueda()"
                      >Filtrar</v-btn
                    >
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-btn color="green" dark class="mb-2 mr-2" @click="descargar()">
              Descargar
            </v-btn>
            <v-btn color="primary" dark class="mb-2" @click="nuevo()"
              >Nuevo</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2 far fa-eye"
                @click="verDetalles(item)"
                v-bind="attrs"
                v-on="on"
              >
              </v-icon>
            </template>
            <span>Ver asistencia</span>
          </v-tooltip>
          <v-tooltip bottom color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2 far fa-edit"
                @click="obtenerRegistro(item)"
                v-bind="attrs"
                v-on="on"
              >
              </v-icon>
            </template>
            <span>Ver servicio</span>
          </v-tooltip>
          <v-tooltip bottom color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="far fa-trash-alt"
                @click="eliminarDialog(item)"
                v-bind="attrs"
                v-on="on"
              >
              </v-icon>
            </template>
            <span>Eliminar servicio</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.pretencionInicial`]="{ item }">
          {{ item.pretencionInicial ? `$ ${item.pretencionInicial}` : "" }}
        </template>
        <template v-slot:[`item.montoConciliado`]="{ item }">
          {{ item.montoConciliado ? `$ ${item.montoConciliado}` : "" }}
        </template>
      </v-data-table>

      <!-- PreLoader -->
      <v-overlay v-model="overlayListar" z-index="0">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackError" color="cyan darken-2" top
        >SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A
        INTENTAR.</v-snackbar
      >

      <v-snackbar v-model="snackEliminado" color="cyan darken-2" top
        >EL SERVICIO INTERNACIONAL SE HA ELIMINADO CORRECTAMENTE.</v-snackbar
      >

      <!-- Formulario nueva asistencia-->
      <v-container class="pa-2 white" v-if="verNuevo == 1">
        <!-- PreLoader -->
        <v-overlay v-model="overlayAsistencia" z-index="1">
          <lottie-player
            autoplay
            loop
            mode="normal"
            src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
            style="width: 320px"
          >
          </lottie-player>
        </v-overlay>
        <!--Contenedor para cliente -->
        <v-container>
          <v-card
            outlined
            width="100%"
            class="pa-2"
            elevation="1"
            style="border: 1px solid black"
          >
            <v-card-title class="pa-0">Datos del Cliente</v-card-title>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="placa"
                  label="Placa"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="polizaBase"
                  label="Poliza"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="marcaBase"
                  label="Marca"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="modeloBase"
                  label="Modelo"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="añoBase"
                  label="Año"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="color"
                  label="Color"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="usoBase"
                  label="Uso"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="titularPolizaBase"
                  label="Ttular Poliza"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="nombreConductor"
                  label="Nombre conductor"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="numeroTelefono"
                  label="Numero Telefono"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="cartera"
                  label="Cartera"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
        <!--Contenedor para datos del servicio -->
        <v-container class="mt-1">
          <v-card
            outlined
            width="100%"
            class="pa-2"
            elevation="1"
            style="border: 1px solid black"
          >
            <v-card-title class="pa-0">Datos del servicio</v-card-title>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="fechaHoraOcurrencia"
                  label="Fecha Ocurrencia"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="proveedor" label="Proveedor" readonly>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="fechaHoraAsignacion"
                  label="Fecha Asignacion"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="align-self-center">
                <v-text-field
                  v-model="pais"
                  label="Pais"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="align-self-center">
                <v-text-field
                  v-model="depaSiniestro"
                  label="Departamento Siniestro"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="align-self-center">
                <v-text-field
                  v-model="muniSiniestro"
                  label="Municipio Siniestro"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea
                  v-model="comDireccionSiniestro"
                  label="Complemento Direccion Siniestro"
                  readonly
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="tipoAsistencia"
                  label="Tipo De Asistencia"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <v-text-field
                  v-model="causa"
                  label="Causa"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="atiende" label="Atiende" readonly>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <v-text-field
                  v-model="depaOrigen"
                  label="Departamento Origen"
                  readonly
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <v-text-field
                  v-model="muniOrigen"
                  label="Municipio Origen"
                  readonly
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea
                  v-model="comDireccionOrigen"
                  label="Complemento Direccion Origen"
                  auto-grow
                  row-height="0"
                  outlined
                  readonly
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <v-text-field
                  v-model="depaDestino"
                  label="Departamento Destino"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <v-text-field
                  v-model="muniDestino"
                  label="Municipio Destino"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea
                  v-model="comDireccionDestino"
                  label="Complemento Direccion Destino"
                  readonly
                  auto-grow
                  row-height="0"
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="placaContraparte"
                  label="Placa Contraparte"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
        <!-- Contenedor para finalizacion del servicio -->
        <v-container class="my-1">
          <v-card
            outlined
            width="100%"
            class="pa-2"
            elevation="1"
            style="border: 1px solid black"
          >
            <v-card-title class="pa-0">Finalización del servicio</v-card-title>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="costoServicio"
                  label="Costo Servicio"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="mb-6 align-self-center">
                <v-text-field
                  v-model="tipoServicio"
                  label="Tipo Servicio"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="mb-6 align-self-center">
                <v-text-field
                  v-model="estatusAsistencia"
                  label="Estatus Asistencia"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="fechaHoraContacto"
                  label="Fecha Contacto"
                  step="1"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="termino"
                  label="Termino"
                  step="1"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea
                  v-model="obsAdicionales"
                  label="Observaciones Adicionales"
                  readonly
                  auto-grow
                  row-height="0"
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="operador" label="Operador" readonly>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="numeroSiniestroQualitas"
                  label="Numero Siniestro Qualitas"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="numeroSpoolerQualitas"
                  label="Numero Spooler Qualitas"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="localForaneo"
                  label="Local/Foraneo"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="partePolicial"
                  label="Hay Parte Policial?"
                  readonly
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="seMovioDelLugar"
                  label="Se Movio Del lugar"
                  readonly
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="zonaPeligrosa"
                  label="zona Peligrosa"
                  readonly
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="reporteTardio"
                  label="Reporte Tardio"
                  readonly
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="roboRecuperado"
                  label="Robo Recuperado"
                  readonly
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="recupero"
                  label="Recupero Tercero"
                  readonly
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field
                  v-model="cantRecupero"
                  label="Recupero Tercero"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="estadoEbriedad"
                  label="Estado de ebriedad"
                  readonly
                >
                </v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="fechaHoraCierreAsistencia"
                  label="Fecha Cierre Asistencia"
                  step="1"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-container>

        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-btn @click="ocultarNuevo()" color="cancel">Cerrar</v-btn>
        </v-flex>
      </v-container>

      <v-dialog max-width="700" persistent v-model="dialog">
        <v-card>
          <v-toolbar color="primary" dark>{{ tituloToolbar }}</v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="numeroAsistencia"
                    label="NUMERO DE ASISTENCIA"
                    @keyup.enter="BuscarNumeroAsistencia()"
                    hint="PRESIONE ENTER PARA COLOCAR LA ASEGURADORA Y PLACA AUTOMATICAMENTE"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3">
                  <v-text-field
                    v-model="aseguradora"
                    label="ASEGURADORA"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-text-field
                    v-model="placa"
                    label="PLACA"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="gestion"
                    :items="itemsGestion"
                    label="GESTION"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="estado"
                    :items="itemsEstado"
                    label="ESTADO"
                    hide-details
                  ></v-select>
                </v-col>
                <v-row>
                  <v-col>
                    <v-text-field
                      type="number"
                      v-model="montoConciliado"
                      label="Monto Conciliado"
                      step="0.1"
                      min="0"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      type="number"
                      v-model="pretencionInicial"
                      label="Pretención Inicial"
                      step="0.1"
                      min="0"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="comentario"
                      label="COMENTARIO"
                      auto-grow
                      rows="1"
                      outlined
                      counter
                      maxlength="1000"
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn text @click="closeDialog()">Cerrar</v-btn>
            <v-btn text @click="guardar()" v-if="estadoNuevo == 1"
              >Guardar</v-btn
            >
            <v-btn text @click="actualizar()" v-if="estadoNuevo == 2"
              >Actualizar</v-btn
            >
            <v-btn
              color="red"
              @click="eliminar()"
              dark
              text
              v-if="estadoNuevo == 3"
              >Eliminar</v-btn
            >
          </v-card-actions>
        </v-card>

        <!-- PreLoader -->
        <v-overlay v-model="overlay">
          <lottie-player
            autoplay
            loop
            mode="normal"
            src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
            style="width: 320px"
          >
          </lottie-player>
        </v-overlay>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
export default {
  data() {
    return {
      servicios: [],
      headers: [
        {
          text: "Opciones",
          align: "center",
          value: "action",
          sortable: false,
          width: 100,
        },
        {
          text: "Número Asistencia",
          value: "numeroAsistencia",
          align: "left",
        },
        {
          text: "Fecha Creación",
          value: "fechaCreacion",
          align: "left",
        },
        {
          text: "Aseguradora",
          value: "aseguradora",
          align: "left",
        },
        {
          text: "Placa",
          value: "placa",
          align: "left",
        },
        {
          text: "Gestión",
          value: "gestion",
          align: "left",
        },
        {
          text: "Pretención Inicial",
          value: "pretencionInicial",
          align: "center",
        },
        {
          text: "Monto Conciliado",
          value: "montoConciliado",
          align: "center",
        },
        {
          text: "Estado",
          value: "estado",
          align: "left",
        },
      ],
      // fechaEnvioInforme: null,
      // fechaRecepcionPresupuesto: null,
      // fechaValuoDaños: null,
      // fechaSolicitudCheque: null,
      // fechaEntregaCheque: null,
      // fechaFinalizado: null,
      search: "",
      dialog: false,
      datosInformeExcel: [],
      verNuevo: 0,
      estadoNuevo: 0,
      overlay: false,
      overlayAsistencia: false,
      overlayListar: false,
      snackError: false,
      snackEliminado: false,
      tituloToolbar: "Agregar nuevo servicio internacional",
      arrayAsistencias: [],
      idServicioInternacional: "",
      idCabina: "",
      numeroAsistencia: "",
      fechaCreacion: "",
      aseguradora: "",
      placa: "",
      gestion: "",
      montoConciliado: null,
      pretencionInicial: null,
      itemsGestion: [
        "AJUSTE DE PRESOPUESTO",
        "CHEQUE ENTREGADO EN EL SALVADOR POR MEDIO DE AR",
        "PAGO REALIZADO POR PROVEEDOR EXTERNO",
        "SUBROGACION",
        "TRAMITE CON ASEGURADORA",
        "LEGAL-ADMINISTRATIVO",
        "CERRADO POR IND. ASEG",
        "DEPOSITO",
        "PAGADO POR MEDIO DE AR",
        "DEPOSITO A EXTERNOS",
      ],
      estado: "",
      comentario: "",
      itemsEstado: ["FINALIZADO", "PROCESO"],
      menuFechas: false,
      fechaInicio: "",
      fechaFin: "",
      //VARIABLES DE CABINA
      idBase: "",
      idProveedor: "",
      idUsuario: "",
      fechaHoraActual: "",
      fechaHoraOcurrencia: "",
      numeroTelefono: "",
      polizaBase: "",
      modeloBase: "",
      marcaBase: "",
      añoBase: 0,
      usoBase: "",
      titularPolizaBase: "",
      cartera: "",
      condicion: "",
      color: "",
      nombreConductor: "",
      asegurado: "",
      pais: "",
      depaSiniestro: "",
      muniSiniestro: "",
      comDireccionSiniestro: "",
      causa: "",
      tipoServicio: "",
      proveedor: "",
      telefonoProveedor: "",
      atiende: "",
      fechaHoraAsignacion: "",
      depaOrigen: "",
      muniOrigen: "",
      comDireccionOrigen: "",
      depaDestino: "",
      muniDestino: "",
      comDireccionDestino: "",
      fechaHoraContacto: "",
      costoServicio: 0,
      fechaHoraCierreAsistencia: "",
      placaContraparte: "",
      partePolicial: false,
      obsAdicionales: "",
      tipoAsistencia: "",
      numeroSiniestroQualitas: "",
      numeroSpoolerQualitas: "",
      seMovioDelLugar: false,
      zonaPeligrosa: false,
      reporteTardio: false,
      roboRecuperado: false,
      localForaneo: "",
      operador: "",
      estatusAsistencia: "",
      recupero: false,
      cantRecupero: "",
      termino: "",
      estadoEbriedad: false,
    };
  },
  created() {
    this.listar();
  },
  methods: {
    getFechaHoraActual() {
      let today = new Date();
      let fechaGuardado =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      return fechaGuardado;
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    nuevo() {
      this.estadoNuevo = 1;
      this.dialog = true;
      this.tituloToolbar = "Nuevo servicio internacional";
      var today = new Date();
      this.fechaCreacion =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
    },
    closeDialog() {
      this.estadoNuevo = 0;
      this.limpiar();
      this.listar();
    },
    listarBusqueda() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.overlayListar = true;
      axios
        .get(
          "api/ServiciosInternacionales/FiltrarServicios/" +
            me.fechaInicio +
            "/" +
            me.fechaFin,
          configuracion
        )
        .then((response) => {
          this.servicios = response.data;
          this.obtenerDatosInforme();
          if (response.status == 200) {
            this.overlayListar = false;
          }
        })
        .catch(function (error) {
          me.overlayListar = false;
          me.snackError = true;
          console.log(error);
        });
    },
    obtenerDatosInforme() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/ServiciosInternacionales/Informe?fechaInicio=${this.fechaInicio}&fechaFin=${this.fechaFin}`,
          configuracion
        )
        .then((res) => {
          this.datosInformeExcel = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    listar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.servicios = [];
      me.overlayListar = true;
      axios
        .get("api/ServiciosInternacionales/Listar", configuracion)
        .then((response) => {
          this.servicios = response.data;
          if (response.status == 200) {
            this.overlayListar = false;
          }

          this.obtenerDatosInforme();

          this.arrayAsistencias = this.servicios.map(
            (serv) => serv.numeroAsistencia
          );
        })
        .catch(function (error) {
          me.overlayListar = false;
          me.snackError = true;
          console.log(error);
        });
    },
    obtenerNumerosAsistencias(data) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.arrayAsistencias = [];
      for (var i = 0; i < data.length; i++) {
        axios
          .get(
            "api/Cabinas/DetallexNumAsistencia/" + data[i]["numeroAsistencia"],
            configuracion
          )
          .then(function (response) {
            response.data.map(function (element) {
              me.arrayAsistencias.push(element);
            });
          })
          .catch(function (error) {
            me.snackError = true;
            console.log(error);
          });
      }
    },
    BuscarNumeroAsistencia() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .get(
          "api/Cabinas/DetallexNumAsistencia/" + this.numeroAsistencia,
          configuracion
        )
        .then(function (response) {
          me.idCabina = response.data[0].idCabina;
          me.aseguradora = response.data[0].cartera;
          me.placa = response.data[0].placa;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    obtenerDetallesAsistencia(idAsistencia) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.overlayAsistencia = true;
      axios
        .get("api/Cabinas/DetallexNumAsistencia/" + idAsistencia, configuracion)
        .then(function (response) {
          if (response.status == 200) {
            me.overlayAsistencia = false;
          }
          me.verDetallesAsistencia(response.data);
        })
        .catch(function (error) {
          console.log(error);
          me.overlayAsistencia = false;
        });
    },
    verDetalles(item) {
      this.verNuevo = 1;
      this.obtenerDetallesAsistencia(item.numeroAsistencia);
      this.verificarRecupero();
    },
    verDetallesAsistencia(item) {
      this.idCabina = item[0].idCabina;
      this.idBase = item[0].idBase;
      this.idUsuario = item[0].idUsuario;
      this.idProveedor = item[0].idProveedor;
      this.fechaHoraActual = item[0].fechaHoraActual;
      this.numeroAsistencia = item[0].numeroAsistencia;
      this.cartera = item[0].cartera;
      this.fechaHoraOcurrencia = item[0].fechaHoraOcurrencia;
      this.numeroTelefono = item[0].numeroTelefono;
      this.placa = item[0].placa;
      this.polizaBase = item[0].polizaBase;
      this.marcaBase = item[0].marcaBase;
      this.modeloBase = item[0].modeloBase;
      this.añoBase = item[0].añoBase;
      this.usoBase = item[0].usoBase;
      this.titularPolizaBase = item[0].titularPolizaBase;
      this.color = item[0].color;
      this.nombreConductor = item[0].nombreConductor;
      this.pais = item[0].pais;
      this.depaSiniestro = item[0].depaSiniestro;
      this.muniSiniestro = item[0].muniSiniestro;
      this.comDireccionSiniestro = item[0].comDireccionSiniestro;
      this.causa = item[0].causa;
      this.tipoServicio = item[0].tipoServicio;
      this.proveedor = item[0].proveedor;
      this.telefonoProveedor = item[0].telefonoProveedor;
      this.atiende = item[0].atiende;
      this.fechaHoraAsignacion = item[0].fechaHoraAsignacion;
      this.depaOrigen = item[0].depaOrigen;
      this.muniOrigen = item[0].muniOrigen;
      this.comDireccionOrigen = item[0].comDireccionOrigen;
      this.depaDestino = item[0].depaDestino;
      this.muniDestino = item[0].muniDestino;
      this.comDireccionDestino = item[0].comDireccionDestino;
      this.fechaHoraContacto = item[0].fechaHoraContacto;
      this.costoServicio = item[0].costoServicio;
      this.fechaHoraCierreAsistencia = item[0].fechaHoraCierreAsistencia;
      this.placaContraparte = item[0].placaContraparte;
      this.partePolicial = item[0].partePolicial;
      this.obsAdicionales = item[0].obsAdicionales;
      this.tipoAsistencia = item[0].tipoAsistencia;
      this.operador = item[0].operador;
      this.numeroSiniestroQualitas = item[0].numeroSiniestroQualitas;
      this.numeroSpoolerQualitas = item[0].numeroSpoolerQualitas;
      this.seMovioDelLugar = item[0].seMovioDelLugar;
      this.zonaPeligrosa = item[0].zonaPeligrosa;
      this.reporteTardio = item[0].reporteTardio;
      this.estatusAsistencia = item[0].estatusAsistencia;
      this.roboRecuperado = item[0].roboRecuperado;
      this.localForaneo = item[0].localForaneo;
      this.cantRecupero = item[0].cantRecupero;
      this.termino = item[0].termino;
      this.estadoEbriedad = item[0].estadoEbriedad;
    },
    verDetallesRegistro(item) {
      this.estadoNuevo = 2;
      this.tituloToolbar = "Detalles del servicio internacional";
      this.idServicioInternacional = item.idServicioInternacional;
      this.idCabina = item.idCabina;
      this.fechaCreacion = item.fechaCreacion;
      this.numeroAsistencia = item.numeroAsistencia;
      this.aseguradora = item.aseguradora;
      this.placa = item.placa;
      this.gestion = item.gestion;
      this.montoConciliado = item.montoConciliado;
      this.pretencionInicial = item.pretencionInicial;
      this.estado = item.estado;
      this.comentario = item.comentario;
      this.overlay = false;

      // this.fechaEnvioInforme = item[0].fechaEnvioInforme;
      // this.fechaRecepcionPresupuesto = item[0].fechaRecepcionPresupuesto;
      // this.fechaValuoDaños = item[0].fechaValuoDaños;
      // this.fechaSolicitudCheque = item[0].fechaSolicitudCheque;
      // this.fechaFinalizado = item[0].fechaFinalizado;
      // this.fechaEntregaCheque = item[0].fechaEntregaCheque;
    },
    eliminarDialog(item) {
      let me = this;
      me.dialog = true;
      me.estadoNuevo = 3;
      me.tituloToolbar = "Eliminar servicio internacional";
      me.idServicioInternacional = item.idServicioInternacional;
      me.idCabina = item.idCabina;
      me.numeroAsistencia = item.numeroAsistencia;
      me.aseguradora = item.aseguradora;
      me.placa = item.placa;
      me.gestion = item.gestion;
      this.montoConciliado = item.montoConciliado;
      this.pretencionInicial = item.pretencionInicial;
      me.estado = item.estado;
      me.comentario = item.comentario;
      me.fechaCreacion = item.fechaCreacion;
    },
    obtenerRegistro(item) {
      this.dialog = true;
      this.verDetallesRegistro(item);
      // let header = { Authorization: "Bearer " + this.$store.state.token };
      // let configuracion = { headers: header };
      // let me = this;
      // me.overlay = true;
      // axios
      //   .get(
      //     "api/ServiciosInternacionales/ListarRegistro/" +
      //       item.numeroAsistencia,
      //     configuracion
      //   )
      //   .then(function (response) {
      //     me.verDetallesRegistro(response.data);
      //   })
      //   .catch(function (error) {
      //     me.overlay = false;
      //     console.log(error);
      //   });
    },
    guardar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.overlay = true;
      axios
        .post(
          "api/ServiciosInternacionales/Crear",
          {
            idCabina: me.idCabina,
            fechaCreacion: me.fechaCreacion,
            numeroAsistencia: me.numeroAsistencia,
            aseguradora: me.aseguradora,
            placa: me.placa,
            gestion: me.gestion,
            pretencionInicial: this.pretencionInicial,
            montoConciliado: this.montoConciliado,
            estado: me.estado,
            comentario: me.comentario,
            // fechaEnvioInforme: this.fechaEnvioInforme,
            // fechaRecepcionPresupuesto: this.fechaRecepcionPresupuesto,
            // fechaValuoDaños: this.fechaValuoDaños,
            // fechaSolicitudCheque: this.fechaSolicitudCheque,
            // fechaEntregaCheque: this.fechaEntregaCheque,
            // fechaFinalizado: this.fechaFinalizado,
          },
          configuracion
        )
        .then(function (response) {
          me.overlay = false;
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.overlay = false;
          me.snackError = true;
          console.log(error);
        });
    },
    actualizar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.overlay = true;
      axios
        .put(
          "api/ServiciosInternacionales/Actualizar",
          {
            idServicioInternacional: me.idServicioInternacional,
            idCabina: me.idCabina,
            fechaCreacion: me.fechaCreacion,
            numeroAsistencia: me.numeroAsistencia,
            aseguradora: me.aseguradora,
            placa: me.placa,
            gestion: me.gestion,
            montoConciliado: this.montoConciliado,
            pretencionInicial: this.pretencionInicial,
            estado: me.estado,
            comentario: me.comentario,
            // fechaEnvioInforme: this.fechaEnvioInforme,
            // fechaRecepcionPresupuesto: this.fechaRecepcionPresupuesto,
            // fechaValuoDaños: this.fechaValuoDaños,
            // fechaSolicitudCheque: this.fechaSolicitudCheque,
            // fechaEntregaCheque: this.fechaEntregaCheque,
            // fechaFinalizado: this.fechaFinalizado,
          },
          configuracion
        )
        .then(function (response) {
          me.overlay = false;
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.overlay = false;
          me.snackError = true;
          console.log(error);
        });
    },
    eliminar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.overlay = true;
      axios
        .delete(
          "api/ServiciosInternacionales/Eliminar/" + me.idServicioInternacional,
          configuracion
        )
        .then(function (response) {
          me.overlay = false;
          me.snackEliminado = true;
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.overlay = false;
          me.snackError = true;
          console.log(error);
        });
    },
    limpiar() {
      this.dialog = false;
      this.estadoNuevo = 0;
      this.tituloToolbar = "";
      this.idServicioInternacional = "";
      this.idCabina = "";
      this.fechaCreacion = "";
      this.numeroAsistencia = "";
      this.aseguradora = "";
      this.placa = "";
      this.gestion = "";
      this.pretencionInicial = null;
      this.montoConciliado = null;
      this.estado = "";
      this.comentario = "";
      //VARIABLES DE CABINA
      this.idBase = "";
      this.idUsuario = "";
      this.idProveedor = "";
      this.fechaHoraActual = "";
      this.cartera = "";
      this.fechaHoraOcurrencia = "";
      this.numeroTelefono = "";
      this.polizaBase = "";
      this.marcaBase = "";
      this.modeloBase = "";
      this.añoBase = "";
      this.usoBase = "";
      this.titularPolizaBase = "";
      this.color = "";
      this.nombreConductor = "";
      this.pais = "";
      this.depaSiniestro = "";
      this.muniSiniestro = "";
      this.comDireccionSiniestro = "";
      this.causa = "";
      this.tipoServicio = "";
      this.proveedor = "";
      this.telefonoProveedor = "";
      this.atiende = "";
      this.fechaHoraAsignacion = "";
      this.depaOrigen = "";
      this.muniOrigen = "";
      this.comDireccionOrigen = "";
      this.depaDestino = "";
      this.muniDestino = "";
      this.comDireccionDestino = "";
      this.fechaHoraContacto = "";
      this.costoServicio = "";
      this.fechaHoraCierreAsistencia = "";
      this.placaContraparte = "";
      this.partePolicial = false;
      this.obsAdicionales = "";
      this.tipoAsistencia = "";
      this.operador = "";
      this.numeroSiniestroQualitas = "";
      this.numeroSpoolerQualitas = "";
      this.seMovioDelLugar = false;
      this.zonaPeligrosa = false;
      this.reporteTardio = false;
      this.estatusAsistencia = "";
      this.roboRecuperado = false;
      this.localForaneo = "";
      this.recupero = false;
      this.cantRecupero = "";
      this.termino = "";
      this.estadoEbriedad = false;

      // this.fechaEnvioInforme = null;
      // this.fechaRecepcionPresupuesto = null;
      // this.fechaValuoDaños = null;
      // this.fechaSolicitudCheque = null;
      // this.fechaEntregaCheque = null;
      // this.fechaFinalizado = null;
    },
    descargar() {
      if (this.datosInformeExcel.length == 0) return;

      const filteredInfo = this.datosInformeExcel.map((s) => {
        return {
          "NUMERO ASISTENCIA": s.numeroAsistencia,
          POLIZA: s.poliza,
          ASEGURADORA: s.aseguradora,
          "FECHA ASISTENCIA": s.fechaHoraActual,
          "FECHA SERVICIO INTERNACIONAL": s.fechaCreacion,
          PLACA: s.placa,
          PROVEEDOR: s.proveedor,
          PAIS: s.pais,
          GESTION: s.gestion,
          "PRETENCION INICIAL": s.pretencionInicial,
          "MONTO CONCILIADO": s.montoConciliado,
          ESTADO: s.estado,
          COMENTARIO: s.comentario,
        };
      });

      let data = XLSX.utils.json_to_sheet(filteredInfo);
      const workbook = XLSX.utils.book_new();
      const filename = "Servicios";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    exportarExcel() {
      var arrayExcel = [];
      for (var i = 0; i < this.servicios.length; i++) {
        var parserObj = JSON.parse(JSON.stringify(this.arrayAsistencias));
        //console.log("servicios", this.servicios);
        //console.log("asistencias", this.arrayAsistencias);
        arrayExcel.push({
          "Fecha creacion": this.servicios[i]["fechaCreacion"],
          "Numero Asistencia": this.servicios[i]["numeroAsistencia"],
          Aseguradora: this.servicios[i]["aseguradora"],
          Placa: this.servicios[i]["placa"],
          Gestión: this.servicios[i]["gestion"],
          Estado: this.servicios[i]["estado"],
          Comentario: this.servicios[i]["comentario"],
          Atiende: parserObj[i]["atiende"],
          Año: parserObj[i]["añoBase"],
          Recupero: parserObj[i]["cantRecupero"],
          Causa: parserObj[i]["causa"],
          Color: parserObj[i]["color"],
          "Dirección destino": parserObj[i]["comDireccionDestino"],
          "Direccion origen": parserObj[i]["comDireccionOrigen"],
          "Direccion siniestro": parserObj[i]["comDireccionSiniestro"],
          "Costo servicio": parserObj[i]["costoServicio"],
          "Departamento destino": parserObj[i]["depaDestino"],
          "Departamento origen": parserObj[i]["depaOrigen"],
          "Departamento siniestro": parserObj[i]["depaSiniestro"],
          "Estado ebriedad": parserObj[i]["estadoEbriedad"],
          "Estatus asistencia": parserObj[i]["estatusAsistencia"],
          "Fecha Actual": parserObj[i]["fechaHoraActual"],
          "Fecha asignación": parserObj[i]["fechaHoraAsignacion"],
          "Fecha Cierre": parserObj[i]["fechaHoraCierreAsistencia"],
          "Fecha contacto": parserObj[i]["fechaHoraContacto"],
          "Fecha ocurrencia": parserObj[i]["fechaHoraOcurrencia"],
          "Local/Foraneo": parserObj[i]["localForaneo"],
          Marca: parserObj[i]["marcaBase"],
          Modelo: parserObj[i]["modeloBase"],
          "Municipio destino": parserObj[i]["muniDestino"],
          "Municipio origen": parserObj[i]["muniOrigen"],
          "Municipio siniestro": parserObj[i]["muniSiniestro"],
          "Nombre conductor": parserObj[i]["nombreConductor"],
          "Numero qualitas": parserObj[i]["numeroSiniestroQualitas"],
          "Numero Spooler qualitas": parserObj[i]["numeroSpoolerQualitas"],
          "Numero telefono": parserObj[i]["numeroTelefono"],
          "Observaciones adicionales": parserObj[i]["obsAdicionales"],
          Operador: parserObj[i]["operador"],
          Pais: parserObj[i]["pais"],
          "Parte policial": parserObj[i]["partePolicial"],
          "Placa contraparte": parserObj[i]["placaContraparte"],
          Poliza: parserObj[i]["polizaBase"],
          Proveedor: parserObj[i]["proveedor"],
          "Reporte tardio": parserObj[i]["reporteTardio"],
          "Robo recuperado": parserObj[i]["roboRecuperado"],
          "Se movio de lugar": parserObj[i]["seMovioDelLugar"],
          "Telefono Proveedor": parserObj[i]["telefonoProveedor"],
          Termino: parserObj[i]["termino"],
          "Tipo Asistencia": parserObj[i]["tipoAsistencia"],
          "Tipo servicio": parserObj[i]["tipoServicio"],
          "Titular poliza": parserObj[i]["titularPolizaBase"],
          Uso: parserObj[i]["usoBase"],
          "Zona peligrosa": parserObj[i]["zonaPeligrosa"],
        });
      }
      let data = XLSX.utils.json_to_sheet(arrayExcel);
      const workbook = XLSX.utils.book_new();
      const filename = "Servicios";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    verificarRecupero() {
      if (this.cantRecupero != null) {
        //si es campo no esta vacio el checkbox se marcara y mostrara el campo
        this.recupero = true;
      }
    },
  },
};
</script>
